import {ApiResponse} from './apiResponse';
import {getIOSVersion} from "../helpers";

class Api {
    /**
     * @param {string} method
     * @param {string} endpoint
     * @param {Object} requestParams
     * @param {function(ApiResponse)} callback
     */
    static _request(method, endpoint, requestParams, callback) {
        let iosVersion = getIOSVersion();

        if (iosVersion && iosVersion[0] === 11) {
            let url = new URL(endpoint);
            url.searchParams.append('v', Date.now());
            endpoint = url.href;
        }

        fetch(endpoint, {
            method: method,
            body: requestParams ? JSON.stringify(requestParams) : null,
            credentials: 'include',
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json',
            }
        })
            .then((response) => {
                if (!response.ok && response.status !== 422) {
                    throw new Error(response.statusText);
                }

                return response.json();
            })
            .then((responseJson) => callback(new ApiResponse(responseJson)))
            .catch((error) => callback(new ApiResponse({status: false, data: {}, message: error})));
    }

    /**
     * @param {string} endpoint
     * @param {Object} requestParams
     * @param {function(ApiResponse)} callback
     */
    static get(endpoint, requestParams, callback) {
        this._request('GET', endpoint, requestParams, callback);
    }

    /**
     * @param {string} endpoint
     * @param {Object} requestParams
     * @param {function(ApiResponse)} callback
     */
    static post(endpoint, requestParams, callback) {
        this._request('POST', endpoint, requestParams, callback);
    }

    /**
     * @param {string} endpoint
     * @param {Object} requestParams
     * @param {function(ApiResponse)} callback
     */
    static put(endpoint, requestParams, callback) {
        this._request('PUT', endpoint, requestParams, callback);
    }

    /**
     * @param {string} endpoint
     * @param {Object} requestParams
     */
    static postSubmitWithReload(endpoint, requestParams= {}) {
        this.post(endpoint, requestParams, () => location.reload());
    }

    /**
     * @param {string} endpoint
     * @param {Object} requestParams
     */
    static postSubmitSynchronous(endpoint, requestParams= {}) {
        let form = document.createElement('form');
        form.setAttribute('action', endpoint);
        form.setAttribute('method', 'POST');

        const input = document.createElement('input');
        input.name = '_token';
        input.value = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        form.appendChild(input);

        for (let key in requestParams) {
            const input = document.createElement('input');
            input.name = key;
            input.value = requestParams[key];
            form.appendChild(input);
        }

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }
}

export {Api};
